import * as React from 'react'
import {useRef} from 'react'
import {DataObjectId, Hub, HubData, PermissionRoleKey} from 'yougile-model'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {EventBus} from '../../client/event-bus'
import {openProjectParticipants} from '../../client/events'
import {Sync} from '../../client/sync'
import {UserAccess} from '../../extensions/user-access'
import {UserUtils} from '../../extensions/user-utils'
import {ProjectParticipantsBase} from './project-participants-base'

export const ProjectParticipants = () => {
  // добавил projectRef, так как были конфликты в useSyncEvent
  // project был undefined, если быстро переотрыть
  // попап после изменения списка пользователей в проекте
  const projectRef = useRef<Hub | undefined>()
  const forceUpdate = useForceUpdate()

  const [allUsers, setAllUsers] = React.useState(() =>
    getUsers(projectRef.current)
  )
  const [requestedNewRole, setRequestedNewRole] = React.useState(false)

  useSyncEvent(
    'current',
    {debounceTime: 1000, filter: '*'},
    () => {
      const users = getUsers(projectRef.current)

      if (users.length !== allUsers.length) {
        setAllUsers(users)
      }
    },
    [projectRef.current, allUsers]
  )

  const processEvent = (data: {project: Hub; newRole?: boolean}) => {
    setRequestedNewRole(data.newRole)

    projectRef.current = data.project
    forceUpdate()

    setAllUsers(getUsers(data.project))
  }
  React.useEffect(() => {
    EventBus.on(openProjectParticipants, processEvent)
    return () => EventBus.off(openProjectParticipants, processEvent)
  }, [])

  const roles: {[userId: string]: PermissionRoleKey} = {}
  if (projectRef.current) {
    UserAccess.listUsersInProject(projectRef.current).forEach(u => {
      const role = UserAccess.getRoleInProject(u.id, projectRef.current)
      roles[u.id] = role
    })
  }
  const close = () => {
    projectRef.current = undefined
    forceUpdate()
  }

  const save = (
    _id: DataObjectId,
    _title: string,
    chosen: {[userId: string]: PermissionRoleKey},
    _addedRoles: HubData['roles']
  ): void => {
    const project = projectRef.current
    close()
    allUsers.forEach(u => {
      if (!chosen[u.id]) {
        if (UserAccess.getRoleInProject(u.id, project)) {
          UserAccess.removeRoleInProject(u.id, project)
        }
      } else {
        const newRole = chosen[u.id] || 'worker'
        if (UserAccess.getRoleInProject(u.id, project) !== newRole) {
          UserAccess.setRoleInProject(u.id, project, newRole)
        }
      }
    })
  }

  if (!projectRef.current) {
    return <div />
  }

  return (
    <ProjectParticipantsBase
      project={projectRef.current}
      allUsers={allUsers}
      roles={roles}
      save={save}
      close={close}
      requestedNewRole={requestedNewRole}
    />
  )
}

const getUsers = (pr: Hub) => {
  if (!pr) {
    return []
  }
  const box = Sync.get(pr)
  return UserUtils.sortByName(box.getAllUsers(false))
}
